import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
function FaqItem({
  title,
  children,
  isOpen,
  onClick
}: {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="border-b border-white/10" data-id="element-228">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" onClick={onClick} data-id="element-229">
        <span className={`text-lg font-medium transition-colors ${isOpen ? 'text-[#c9a84c]' : 'text-white group-hover:text-[#c9a84c]'}`} data-id="element-230">
          {title}
        </span>
        <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#c9a84c]' : 'text-white/50'}`} data-id="element-231" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-232">
        <p className="text-white/70 leading-relaxed" data-id="element-233">{children}</p>
      </div>
    </div>;
}
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'How much does a website cost in Dublin?',
    a: 'Most Dublin web design agencies charge between €1,000 and €3,000 for a basic business website. Our package is just €249 one-time because we use efficient AI-powered tools to build professional sites faster, passing the savings directly to you.'
  }, {
    q: 'Do you build websites for specific industries in Ireland?',
    a: 'Yes! We specialise in websites for electricians, plumbers, restaurants, barbers, hotels, and all local trades in Dublin and across Ireland. We understand what Irish customers look for when hiring local services.'
  }, {
    q: 'Can you help my Dublin business rank on Google?',
    a: 'Absolutely. All our websites are built with an SEO-friendly structure, fast loading speeds, and mobile responsiveness — key factors for ranking on Google Ireland. We also include basic on-page SEO setup to help customers find you.'
  }, {
    q: "What's included in the €249 package?",
    a: 'Full custom website build, mobile responsive design, contact form, WhatsApp integration, Google Maps, basic analytics, 1-year Hobby plan ($180 value), 100 monthly AI editing requests, 1 year of fast hosting included, and up to 3 rounds of revisions.'
  }, {
    q: 'What about hosting and domain?',
    a: '1 year of fast, reliable hosting is included in every package at no extra cost. Domain registration is purchased separately — or we can handle it for you for a small extra fee.'
  }, {
    q: 'How fast will my website be ready?',
    a: 'Typically within 48 hours after we receive all your content (text, images, logo). The faster you send materials, the faster we deliver.'
  }, {
    q: 'How many revisions do I get?',
    a: 'Up to 3 rounds of revisions are included. After that, you can use your 100 monthly AI requests to make changes yourself.'
  }, {
    q: 'Can I edit the website myself after launch?',
    a: 'Yes! Your plan includes 100 AI-assisted editing requests per month. Just describe what you want changed and the AI handles it.'
  }, {
    q: 'Is this only for Dublin businesses?',
    a: "We prioritize Dublin businesses for faster, more personal support. However, we're happy to work with businesses in other locations too."
  }, {
    q: "What if I need more than what's included?",
    a: 'We can discuss additional features or pages at a fair price. Just ask!'
  }];
  return <section id="faq" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#080808'
  }} data-id="element-234">
      <div className="max-w-3xl mx-auto" data-id="element-235">
        <div className="text-center mb-12 reveal" data-id="element-236">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-237">
            Website Design Dublin — Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-2 reveal" data-id="element-238">
          {faqs.map((faq, idx) => <FaqItem key={idx} title={faq.q} isOpen={openIndex === idx} onClick={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-239">
              {faq.a}
            </FaqItem>)}
        </div>
      </div>
      <SectionDivider data-id="element-240" />
    </section>;
}